
import { create } from 'zustand';

export interface PaymentMethod {
  id: string;
  type: string;
  brand: string;
  last4: string;
  expiryMonth: number;
  expiryYear: number;
  isDefault: boolean;
}

export interface Invoice {
  id: string;
  amount: number;
  status: string;
  date: string;
  pdfUrl: string;
}

export interface Subscription {
  id: string;
  status: string;
  plan: string;
  currentPeriodStart: string;
  currentPeriodEnd: string;
}

interface PaymentState {
  paymentMethods: PaymentMethod[];
  invoices: Invoice[];
  subscription: Subscription | null;
  isLoading: boolean;
  error: string | null;
  
  setPaymentMethods: (methods: PaymentMethod[]) => void;
  addPaymentMethod: (method: PaymentMethod) => void;
  removePaymentMethod: (id: string) => void;
  setInvoices: (invoices: Invoice[]) => void;
  setSubscription: (subscription: Subscription | null) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
}

const usePaymentStore = create<PaymentState>((set, get) => ({
  paymentMethods: [],
  invoices: [],
  subscription: null,
  isLoading: false,
  error: null,
  
  setPaymentMethods: (paymentMethods) => set({ paymentMethods }),
  
  addPaymentMethod: (method) => set({ 
    paymentMethods: [...get().paymentMethods, method] 
  }),
  
  removePaymentMethod: (id) => set({ 
    paymentMethods: get().paymentMethods.filter(method => method.id !== id) 
  }),
  
  setInvoices: (invoices) => set({ invoices }),
  setSubscription: (subscription) => set({ subscription }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
}));

export default usePaymentStore;
